// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OMwS","comment":"styles_comment__3pa2i"};